const COLUMNS = {
  nickname: 'nickname',
  last_name: 'last_name',
  first_name: 'first_name',
  last_name_seimei: 'last_name',
  first_name_seimei: 'first_name',
  last_name_kana: 'last_name_kana',
  first_name_kana: 'first_name_kana',
  gender: 'gender',
  blood: 'blood',
  birthorder: 'birthorder',
  birthday: 'birth_date',
  birthtime: 'birth_time',
  birthtime_unknown: 'birthtime_unknown',
  from_pref: 'born_place',
  job: 'job',
  relationship: 'relationship',
  love_status: 'love_status',
  living_place: 'living_place',
  target_nickname: 'partner_nickname',
  target_birthday: 'partner_birth_date',
  target_birthtime: 'partner_birth_time',
  target_birthtime_unknown: 'partner_birth_time_unknown',
  target_gender: 'partner_gender',
  target_from_pref: 'partner_born_place',
  target_born_place_oversea: 'partner_born_place_oversea',
  target_first_name: 'partner_first_name',
  target_first_name_kana: 'partner_first_name_kana',
  target_last_name: 'partner_last_name',
  target_last_name_kana: 'partner_last_name_kana',
  target_birthorder: 'partner_birthorder',
  target_blood: 'partner_blood',
  target_job: 'partner_job',
  target_love_status: 'partner_love_status',
  target_living_place: 'partner_living_place'
}

const PREFS = [
  { newValue: null, value: '' },
  { newValue: 0, value: 'その他・不明' },
  { newValue: 1, value: '北海道' },
  { newValue: 2, value: '青森県' },
  { newValue: 3, value: '岩手県' },
  { newValue: 4, value: '宮城県' },
  { newValue: 5, value: '秋田県' },
  { newValue: 6, value: '山形県' },
  { newValue: 7, value: '福島県' },
  { newValue: 8, value: '茨城県' },
  { newValue: 9, value: '栃木県' },
  { newValue: 10, value: '群馬県' },
  { newValue: 11, value: '埼玉県' },
  { newValue: 12, value: '千葉県' },
  { newValue: 13, value: '東京都' },
  { newValue: 14, value: '神奈川県' },
  { newValue: 15, value: '新潟県' },
  { newValue: 16, value: '富山県' },
  { newValue: 17, value: '石川県' },
  { newValue: 18, value: '福井県' },
  { newValue: 19, value: '山梨県' },
  { newValue: 20, value: '長野県' },
  { newValue: 21, value: '岐阜県' },
  { newValue: 22, value: '静岡県' },
  { newValue: 23, value: '愛知県' },
  { newValue: 24, value: '三重県' },
  { newValue: 25, value: '滋賀県' },
  { newValue: 26, value: '京都府' },
  { newValue: 27, value: '大阪府' },
  { newValue: 28, value: '兵庫県' },
  { newValue: 29, value: '奈良県' },
  { newValue: 30, value: '和歌山県' },
  { newValue: 31, value: '鳥取県' },
  { newValue: 32, value: '島根県' },
  { newValue: 33, value: '岡山県' },
  { newValue: 34, value: '広島県' },
  { newValue: 35, value: '山口県' },
  { newValue: 36, value: '徳島県' },
  { newValue: 37, value: '香川県' },
  { newValue: 38, value: '愛媛県' },
  { newValue: 39, value: '高知県' },
  { newValue: 40, value: '福岡県' },
  { newValue: 41, value: '佐賀県' },
  { newValue: 42, value: '長崎県' },
  { newValue: 43, value: '熊本県' },
  { newValue: 44, value: '大分県' },
  { newValue: 45, value: '宮崎県' },
  { newValue: 46, value: '鹿児島県' },
  { newValue: 47, value: '沖縄県' },
  { newValue: 99, value: '海外' }
]

const GENDERS = [{ newValue: 1, value: 'F' }, { newValue: 2, value: 'M' }]

const convertKey = name => (COLUMNS[name] ? COLUMNS[name] : name)

const convertValue = function(key, value) {
  if (value === '') {
    return value
  }

  let newValue = value
  switch (key) {
    case 'birthday':
    case 'target_birthday': {
      newValue = value.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')
      break
    }
    case 'birthtime':
    case 'target_birthtime': {
      newValue = value.replace(/(\d{2})(\d{2})/g, '$1:$2:00')
      break
    }
    case 'gender':
    case 'target_gender': {
      const item = GENDERS.find(gender => value === gender.value)
      newValue = item ? item.newValue : value
      break
    }
    case 'from_pref':
    case 'target_from_pref': {
      const item = PREFS.find(pref => value === pref.value)
      newValue = item ? item.newValue : '0'
      break
    }
    case 'relationship': {
      newValue = value ? value : 0
      break
    }
    default: {
      newValue = value
      break
    }
  }
  return newValue
}

/**
 * account.uranaitv.jp用にカラム名を修正
 * @param {*} Object - uranaitv.storeで使用している入力フォーマットのオブジェクト
 * @return {Object} - account.uranaitv.jpで使用する入力フォーマットのオブジェクト
 */
export default (params = {}) => {
  const newParams = {}
  Object.keys(params).forEach(key => {
    Object.assign(newParams, {
      [convertKey(key)]: convertValue(key, params[key])
    })
  })

  // 出生時間不明の処理
  if ('birth_time' in newParams) {
    const unknownFlg = Number(newParams['birth_time'] === '99:99:00')
    Object.assign(newParams, {
      birth_time_unknown: unknownFlg
    })
    if (unknownFlg) {
      delete newParams['birth_time']
      delete newParams['birthtime_unknown']
    }
  }

  // 出生時間不明の処理(相手)
  if ('partner_birth_time' in newParams) {
    const unknownFlg = Number(newParams['partner_birth_time'] === '99:99:00')
    Object.assign(newParams, {
      partner_birth_time_unknown: unknownFlg
    })
    if (unknownFlg) {
      delete newParams['partner_birth_time']
      delete newParams['target_birthtime_unknown']
    }
  }
  return newParams
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/convertUserInfo.js